import NavBar from "../../Component/NavBar/NavBar";
import {IoIosAddCircleOutline} from "react-icons/io";
import React, {useEffect, useState} from "react";
import {BiSolidUserDetail} from "react-icons/bi";
import {MdOutlineBlock, MdOutlineVerifiedUser} from "react-icons/md";
import Loading from "../../Component/Loading/Loading";
import {useNavigate} from "react-router-dom";
import apiRequests from "../../Component/axios/config/config";




export default function Invoice() {


    const navigate = useNavigate();
    const [invoice, setInvoice] = useState([]);
    const [loading, setLoading] = useState(false);


    const [showModalSee, setShowModalSee] = useState(false);


    function apiGetUser() {
        setLoading(true)
        apiRequests.get("/api/invoice/get-all-seller")
            .then((response) => {
                setInvoice(response.data.data.docs);
            })
            .catch(() => {
            })
            .finally(() => setLoading(false));
    }

    useEffect(() => {
        apiGetUser()
    }, []);

    return (

        <div className="p-6">
            <div className="text-3xl font-bold text-gray-800 mb-6">
                Invoice List
            </div>

            <NavBar item={[
                {
                    icon: <BiSolidUserDetail style={{fontSize: "22px"}}/>, title: "All Invoice List", onClick: () => {
                    }
                },
            ]}/>


            <div className="flex justify-center mt-8">
                <div className="w-full max-w-6xl md:overflow-x-auto">
                    <table className="w-full bg-white shadow-md rounded-lg overflow-hidden">
                        <thead
                            className="bg-gradient-to-r text-left from-buttonColor-shade4 to-marginColor-shade9 text-white">
                        <tr>
                            <th className="px-4 py-2 text-md font-medium rounded-tl-lg">Id order</th>
                            <th className="px-4 py-2 text-md font-medium">User</th>
                            <th className="px-4 py-2 text-md font-medium">Amount Paid</th>
                            <th className="px-4 py-2 text-md font-medium">Status</th>
                            <th className="px-4 py-2 text-md font-medium rounded-tr-lg">Action</th>
                        </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                        {loading ?
                            <tr>
                                <td className="px-4 py-3 text-center" colSpan="4">
                                    <Loading/>
                                </td>
                            </tr>
                            :
                            invoice.length > 0 ?
                                invoice.map((item) =>
                                    <tr key={item._id}>
                                        <td className="px-4 py-3 text-md font-medium rounded-tl-lg"># {item._id.slice(0, 5) || "-"}</td>
                                        <td className="px-4 py-3 text-md font-medium">{item.user_info?.userName}</td>
                                        <td className={`px-4 py-3`}>
                                            $ {item.totalAmount}
                                        </td>
                                        <td className={`px-4 py-4`}>
                                        <span className={`px-2 hover:cursor-pointer py-1 rounded-full text-xs font-medium 
                                            ${item.isDeleted ? 'bg-red-100 text-red-700' : 'bg-green-100 text-green-700'}`}
                                              // onClick={() => ChangeStatusUser(item._id, item.userName, item.isDeleted)}

                                        >
                                            {item.isDeleted ? 'Deleted' : 'Active'}
                                        </span>
                                        </td>
                                        <td className="px-4 py-3 text-md font-medium rounded-tr-lg">
                                            <button
                                                className="text-blue-500 hover:text-blue-700 font-medium mr-4"
                                                onClick={() => navigate(`/invoice/details/${item._id}`)}
                                            >
                                                See More
                                            </button>
                                            {/*<button*/}
                                            {/*    className="text-red-500 hover:text-red-700 font-medium"*/}
                                            {/*>*/}
                                            {/*    Delete*/}
                                            {/*</button>*/}
                                        </td>
                                    </tr>
                                )
                                :
                                <tr className="">
                                    <td className="px-4 py-3 text-center" colSpan="4">Invoice not found!</td>
                                </tr>
                        }


                        </tbody>
                    </table>
                </div>
            </div>


        </div>
    )
}